import styled from "@emotion/styled";

export const ProcessingPageLayout = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.md};
`;
